import { ScopedBlockitRendererContext } from '../../context/scoped.mjs';
import { useContext } from 'react';
export { SubgroupSelect } from './signup/subgroupSelect.mjs';
export { MyShoppingBlock } from './profile/myShopping/index.mjs';

var ScopedBlock = function ScopedBlock(block) {
  var _a;
  var _useContext = useContext(ScopedBlockitRendererContext),
    renderScopedBlock = _useContext.renderScopedBlock;
  return (_a = renderScopedBlock === null || renderScopedBlock === void 0 ? void 0 : renderScopedBlock(block)) !== null && _a !== void 0 ? _a : null;
};

export { ScopedBlock };
